import AppleStore from '../svgs/AppleStore';
import PlayStore from '../svgs/PlayStore';

const CallToActionButton = ({ title, action, store }) => {
  return store ? (
    <div>
      <a href='https://play.google.com/store/apps/details?id=com.emmalion.liontaxi'>
        <PlayStore />
      </a>
      <a href='https://apps.apple.com/app/liontaxi/id1607504124'>
        <AppleStore />
      </a>
    </div>
  ) : (
    <a href={action} className='call-to-action'>
      {title}
    </a>
  );
};

export default CallToActionButton;

CallToActionButton.defaultProps = {
  action: '/download',
};
